const getItem = (key, defaultValue) => {
  try {
    return localStorage.getItem(key) === "true";
  } catch (e) {
    return defaultValue;
  }
};

export default {
  state: {
    cookiesAccepted: getItem("cookiesAccepted", false),
    termsAccepted: getItem("termsAccepted", false),
    ccpaAccepted: getItem("ccpaAccepted", true),
  },

  getters: {
    cookiesAccepted: (state) => state.cookiesAccepted,
    termsAccepted: (state) => state.termsAccepted,
    ccpaAccepted: (state) => state.ccpaAccepted,
  },

  actions: {
    acceptCookies({ state }) {
      state.cookiesAccepted = true;
      localStorage.setItem("cookiesAccepted", "true");
    },

    acceptTerms({ state }) {
      state.termsAccepted = true;
      localStorage.setItem("termsAccepted", "true");
    },

    acceptCCPA({ state }, accepted) {
      accepted = !!accepted;
      state.ccpaAccepted = accepted;
      localStorage.setItem("ccpaAccepted", accepted ? "true" : "false");
    },
  },
};
